export const environments = {
  server: 'https://www.doktortriceratops.cz',
  // server: 'http://testplace.rotterik.cz',
  serverURL: /*process.env.NODE_ENV !== 'production' ? process.env.PUBLIC_URL :*/ 'https://www.doktortriceratops.cz',
  // serverURL: process.env.NODE_ENV !== 'production' ? process.env.PUBLIC_URL : 'http://testplace.rotterik.cz',
  backend: '/backend/getResultFromDB.php',
  pageTitle: 'Oficiální stránka kapely Doktor Triceratops'
}